import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { EButtonType } from "../../data-types/button.enum";
import { EInputStyleType } from "../../data-types/input-style.enum";
import { ETextareaStyleType } from "../../data-types/textarea-style.enum";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormControlName,
  Validators,
} from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { EInputMediaStyleType } from "../../data-types/input-media-style.enum";
import { iconsLibrary } from "../../../theme/constants";
import { NgxCSVParserError, NgxCsvParser } from "ngx-csv-parser";
import { showAlertAction } from "../../store/actions/alert.action";
import { TranslateService } from "@ngx-translate/core";
import { Store } from "@ngrx/store";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { UserService } from "../../services/user.service";
import { IAppState } from "../../store/state/app.state";
import { CompanyService } from "../../services/company.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { EStorageType } from "../../data-types/storage.enum";
import { BackofficeService } from "../../services/backoffice.service";
import { ISpaceType } from "../../data-types/space.interface";
import { CoworkingService } from "../../services/coworking.service";

var window: any;

@Component({
  selector: "cowing-core-backoffice-edit-space",
  templateUrl: "./backoffice-edit-space.component.html",
  styleUrls: ["./backoffice-edit-space.component.scss"],
})
export class BackofficeEditSpaceComponent implements OnInit {
  @Input("spaceId") spaceId = null;
  @Input("closeModal") closeModal;
  public EInputStyleType = EInputStyleType;
  public EButtonType = EButtonType;
  public EInputMediaStyleType = EInputMediaStyleType;
  public ready = false;
  public spaceInfo;
  public spaceTypes: Array<ISpaceType>;
  public selectedType: ISpaceType;
  constructor(
    private formBuilder: FormBuilder,
    private _store: Store<IAppState>,
    private coworkingService: CoworkingService,
    private localStorageService: LocalStorageService
  ) {}
  async ngOnInit() {
    // this.editCompanyForm
    //   .get("is_business_group")
    //   .valueChanges.subscribe((value) => {
    //     const businessGroupName = this.editCompanyForm.get("business_group");

    //     if (value === "No" && businessGroupName.disabled === false) {
    //       businessGroupName.setValidators([]);
    //       businessGroupName.disable();
    //     } else if (value === "Si" && businessGroupName.disabled === true) {
    //       businessGroupName.setValidators([Validators.required]);
    //       businessGroupName.enable();
    //     }
    //     // businessGroupName.setValue("");
    //     businessGroupName.updateValueAndValidity();
    //   });
    await this.getSpace();
  }
  public editSpaceForm = this.formBuilder.array([]);

  async getSpace() {
    try {
      this._store.dispatch(showLoadingAction({}));
      const space: any = await BackofficeService.instance.getSpace(
        this.spaceId
      );
      // Get space types
      this.spaceTypes = await this.coworkingService.getSpaceTypes();
      let index = this.spaceTypes.findIndex((type: ISpaceType) => {
        return type.id === space.type_id;
      });
      if (index !== -1) {
        this.selectedType = this.spaceTypes[index];
      }
      this.spaceInfo = space;
      space.prices.forEach((price) => {
        const group = new FormGroup({});
        group.setControl("private_price", new FormControl(price.private_price));
        group.setControl("public_price", new FormControl(price.public_price));
        group.setControl("id", new FormControl(price.id));
        this.editSpaceForm.push(group);
      });
      //   this.editSpaceForm.addControl(
      //     "price_hour",
      //     new FormControl(
      //       space.prices.find(
      //         (price) => price.label == "price_hour"
      //       ).public_price,
      //       Validators.required
      //     )
      //   );
      //   this.editSpaceForm.addControl(
      //     "price_day",
      //     new FormControl(
      //       space.prices.find((price) => price.label == "price_day").public_price,
      //       Validators.required
      //     )
      //   );
      //   this.editSpaceForm.addControl(
      //     "price_week",
      //     new FormControl(
      //       space.prices.find(
      //         (price) => price.label == "price_week"
      //       ).public_price,
      //       Validators.required
      //     )
      //   );
      //   this.editSpaceForm.addControl(
      //     "price_month",
      //     new FormControl(
      //       space.prices.find(
      //         (price) => price.label == "price_month"
      //       ).public_price,
      //       Validators.required
      //     )
      //   );
    } catch (e) {
      console.error(e);
    } finally {
      this.ready = true;
      this._store.dispatch(closeLoadingAction({}));
    }
  }

  get formControl() {
    return this.editSpaceForm.controls;
  }

  async editSpace() {
    console.log(this.editSpaceForm.value);
    this._store.dispatch(showLoadingAction({}));
    try {
      const response = await BackofficeService.instance.patchSpacePrices(
        this.spaceId,
        { prices: this.editSpaceForm.value }
      );
      const spaceEditted = await BackofficeService.instance.patchSpace(
        this.spaceId,
        {
          quantity: this.spaceInfo.quantity,
          capacity: this.spaceInfo.capacity,
          type_id: this.selectedType.id,
        }
      );
      BackofficeService.instance.spaceModified.next();
      this.closeModal();
    } catch (e) {
      console.error(e);
    } finally {
      this.ready = true;
      this._store.dispatch(closeLoadingAction({}));
    }
  }
  public setLocation(currentLocation) {
    // this._setLocation(currentLocation);
  }
  public _setLocation(location) {
    // this.editCompanyForm.get("latitude").setValue(location.lat);
    // this.editCompanyForm.get("longitude").setValue(location.lng);
    // this.editCompanyForm.get("city").setValue(location.city);
    // this.editCompanyForm.get("country").setValue(location.country);
    // this.editCompanyForm.get("province").setValue(location.province);
  }
  public getErrors() {
    // console.log(this.editCompanyForm.errors);
    // return "";
  }
}
